import React, { Component, ComponentType } from 'react';
import { connect } from 'react-redux';
import { openNewTab } from '../redux/dynamicTabs/actions';

type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

export interface WithDynamicTabLauncherProps {
  openNewTab: (
    data: DynamicTabAttributes,
    history: any,
    noHistoryPush?: boolean,
    tabsAmountOnInit?: number,
    search?: string,
  ) => void;
}

type ComponentProps = object;
type DynamicTabLauncher = ComponentProps & MapDispatchToProps;

/**
 * HOC pozwalający na obsługę dynamicznych zakładek. Dostarcza akcję otwarcia nowej zakładki.
 *
 * @param Cmp
 */
const withDynamicTabLauncher = <P extends ComponentProps>(Cmp: ComponentType<P>) => {
  class Controller extends Component<DynamicTabLauncher> {
    render(): React.ReactElement {
      const { openNewTab, ...rest } = this.props;
      return <Cmp {...(rest as P)} openNewTab={openNewTab} />;
    }
  }
  return connect(null, mapDispatchToProps)(Controller);
};

const mapDispatchToProps = (dispatch: any) => ({
  openNewTab: (data: DynamicTabAttributes, history: any, noHistoryPush?: boolean, tabsAmountOnInit?: number, search?: string) =>
    dispatch(openNewTab(data, history, noHistoryPush, tabsAmountOnInit, search)),
});

export default withDynamicTabLauncher;
